export default __webpack_public_path__ + "static/media/gameI-intro2.88ee0ac7.png";